import PencilIcon from '@/assets/icons/icon-pencil-filled.svg'
import { Button } from '@/components/ui/button'

import { useSalesEditor } from '../hooks/use-sales-editor'

interface Props {
  onClick: () => void
}

export const EditChartButton = ({ onClick }: Props) => {
  const { isEditing, activeTemplate } = useSalesEditor()

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    event.preventDefault()
    event.stopPropagation()
    onClick()
  }

  if (!isEditing || !activeTemplate) {
    return null
  }

  return (
    <Button
      size="icon"
      className="absolute -right-2 top-2 h-6 w-6 -translate-y-1/2 rounded-full"
      onClick={handleClick}
    >
      <PencilIcon />
    </Button>
  )
}
